import { useCallback } from 'react';

import { logger } from '@azure/storage-blob';

import { buildLocationPayload, LocationApi } from '@/api/api.location';
import { LocalStorageItems } from '@/constants';
import { useDeviceDataContext } from '@/hooks/useDeviceData';
import {
  FullMoveCallbackParams,
  useGeolocationTracker,
} from '@/hooks/useGeoLocationTracker';
import { IUser, Role } from '@/models';
import { isTargetRole } from '@/services';
import { useUserStore } from '@/store';

export const useLocationTracking = () => {
  const deviceData = useDeviceDataContext();
  const { user } = useUserStore();

  const handleMove = useCallback(async (data: FullMoveCallbackParams) => {
    const cfsId = localStorage.getItem('cfsId');
    const unitShiftId = localStorage.getItem('assignedUnitShiftId');
    const deviceUID = localStorage.getItem(LocalStorageItems.DeviceUID);

    if (!user) return;
    const targetRole = isTargetRole(user as IUser, Role.FIRST_RESPONDER);

    if (!unitShiftId || !deviceUID || !targetRole) return;

    const location = buildLocationPayload({
      latitude: data.latitude,
      longitude: data.longitude,
      distance: data.distance,
      cfsId,
      unitShiftId,
      timestamp: data.timestamp,
      speed: data.speed,
      heading: data.heading,
      altitudeAccuracy: data.altitudeAccuracy,
      altitude: data.altitude,
      accuracy: data.accuracy,
    });

    try {
      await LocationApi.sendLocation({
        ...location,
        platform: deviceData?.platform ?? '',
        version: deviceData?.version ?? '',
        deviceUID,
      });
      logger.info('Location sent successfully!', location);
    } catch (error) {
      logger.error('Failed to send location:', error);
    }
  }, []);

  useGeolocationTracker(handleMove, 5);
};
